import { render, staticRenderFns } from "./returnMaterialForm.vue?vue&type=template&id=6c6bd26c&scoped=true&"
import script from "./returnMaterialForm.vue?vue&type=script&lang=js&"
export * from "./returnMaterialForm.vue?vue&type=script&lang=js&"
import style0 from "./returnMaterialForm.vue?vue&type=style&index=0&id=6c6bd26c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6bd26c",
  null
  
)

export default component.exports